import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';

export function useShareSplits({ params }) {
  const shareSplits = api.shareSplit.listForCompany.useQuery(
    { companyId: params?.companyId },
    {
      enabled: !!params?.companyId,
    },
  );
  return { shareSplits };
}

export function useMutateShareSplit() {
  const createShareSplit = api.shareSplit.create.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Share split created successfully.',
    }),
  );

  const deleteShareSplit = api.shareSplit.remove.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Share split deleted successfully.',
    }),
  );

  return {
    createShareSplit,
    deleteShareSplit,
  };
}
